import * as actionTypes from './trades.actionTypes';

export type QuoteTradeActions =
  | TradeExecutionCommentChanged
  | ConfirmedExecutionOnlyDealId
  | TradeNotificationContactsChanged;

export function tradeExecutionCommentChanged(quoteId: string, comment: string) {
  return {
    type: actionTypes.TRADE_EXECUTION_COMMENT_CHANGED,
    quoteId,
    comment,
  };
}

type TradeExecutionCommentChanged = ReturnType<typeof tradeExecutionCommentChanged>;

export function tradeNotificationContactsChanged(quoteId: string, contactIds: string[]) {
  return {
    type: actionTypes.TRADE_EXECUTION_NOTIFICATIONS_CHANGED,
    quoteId,
    contactIds,
  };
}
type TradeNotificationContactsChanged = ReturnType<typeof tradeNotificationContactsChanged>;

export function confirmedExecutionOnlyDealId(quoteId: string, dealId: string) {
  return {
    type: actionTypes.TRADES_CONFIRMED_EXECUTION_ONLY_DEAL_ID,
    quoteId,
    dealId,
  };
}

type ConfirmedExecutionOnlyDealId = ReturnType<typeof confirmedExecutionOnlyDealId>;
